import img1 from "./estepona2-1.jpg";
import img2 from "./estepona2-2.jpg";
import img3 from "./estepona2-3.jpg";
import img4 from "./estepona2-4.jpg";
import img5 from "./estepona2-5.jpg";
import img6 from "./estepona2-6.jpg";
import img7 from "./estepona2-7.jpg";
import img8 from "./estepona2-8.jpg";
import img9 from "./estepona2-9.jpg";
import img10 from "./estepona2-10.jpg";
import img11 from "./estepona2-11.jpg";
import img12 from "./estepona2-12.jpg";
import img13 from "./estepona2-13.jpg";
import img14 from "./estepona2-14.jpg";
import img15 from "./estepona2-15.jpg";
import img16 from "./estepona2-16.jpg";
import img17 from "./estepona2-17.jpg";
import img18 from "./estepona2-18.jpg";
import img19 from "./estepona2-19.jpg";
import img20 from "./estepona2-20.jpg";
import img21 from "./estepona2-21.jpg";
import img22 from "./estepona2-22.jpg";
import img23 from "./estepona2-23.jpg";
import img24 from "./estepona2-24.jpg";
import img25 from "./estepona2-25.jpg";
import img26 from "./estepona2-26.jpg";
import img27 from "./estepona2-27.jpg";
import img28 from "./estepona2-28.jpg";
import img29 from "./estepona2-29.jpg";
import img30 from "./estepona2-30.jpg";
import img31 from "./estepona2-31.jpg";
import img32 from "./estepona2-32.jpg";
import img33 from "./estepona2-33.jpg";
import img34 from "./estepona2-34.jpg";
import img35 from "./estepona2-35.jpg";
import img36 from "./estepona2-36.jpg";
import img37 from "./estepona2-37.jpg";
import img38 from "./estepona2-38.jpg";
import img39 from "./estepona2-39.jpg";
import img40 from "./estepona2-40.jpg";
import img41 from "./estepona2-41.jpg";
import img42 from "./estepona2-42.jpg";
import img43 from "./estepona2-43.jpg";
import img44 from "./estepona2-44.jpg";
import img45 from "./estepona2-45.jpg";
import fp3d from "./floorplan-3d.jpg";
import fp2d from "./floorplan-2d.jpg";

export const estepona2Images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42, img43, img44, img45,
];

export const estepona2FloorPlans = [
  { image: fp3d, label: "3D půdorys" },
  { image: fp2d, label: "2D půdorys" },
];
